var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__top py-16"
  }, [_c('v-container', {
    staticClass: "container--sm"
  }, [_c('v-row', {
    staticClass: "row--small footer__link",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/center"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("공지사항")])])], 1), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "menu-line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/center/faqs"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("자주묻는질문")])])], 1), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "menu-line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/service-policy"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("이용약관")])])], 1), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "menu-line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": "grey-6",
      "to": "/privacy-policy"
    }
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("개인정보처리방침")])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "footer__bottom py-48"
  }, [_c('v-container', {
    staticClass: "container--sm"
  }, [_c('v-row', {
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-6 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-img', {
    staticClass: "w-120px w-lg-200px",
    attrs: {
      "src": "/images/ci.svg"
    }
  })], 1), _c('v-col', {
    staticClass: "ml-xl-56",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('p', {
    staticClass: "page-text grey-9--text mb-lg-8"
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("회사명")]), _vm._v(" 주식회사 디엔아이씨"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "16px"
    }
  }), _c('br', {
    staticClass: "d-block d-md-none"
  }), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("주소")]), _vm._v(" 서울시 영등포구 양평로 22길 21, 1406호"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "16px"
    }
  }), _c('br', {
    staticClass: "d-block d-md-none"
  }), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("대표자명")]), _vm._v(" 유지수 ")]), _c('p', {
    staticClass: "page-text grey-9--text"
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("사업자등록번호")]), _vm._v(" 105-86-25713"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "16px"
    }
  }), _c('br', {
    staticClass: "d-block d-md-none"
  }), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("통신판매업신고증")]), _vm._v(" 제 2022-서울영등포-3202호"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "16px"
    }
  }), _c('br', {
    staticClass: "d-block d-md-none"
  }), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("전화")]), _vm._v(" 02)325-9123"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "16px"
    }
  }), _c('br', {
    staticClass: "d-block d-md-none"
  }), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이메일")]), _vm._v(" support@micepec.com "), _c('br')])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }